import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/layout/Sidebar';
import { Spinner } from './components/ui';

import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import BeachMapPage from './pages/BeachMap';
import BeachBuilder from './pages/BeachBuilder';
import Availability from './pages/Availability';
import Tariffe from './pages/Tariffe';
import Settings from './pages/Settings';
import Servizi from './pages/Servizi';
import Promozioni from './pages/Promozioni';
import Eventi from './pages/Eventi';
import Menu from './pages/Menu';
import OrdiniLido from './pages/OrdiniLido';
import SpiaggeIt from './pages/Spieaggeit';

// ─── Protected layout ──────────────────────────────────────────────────────
function AdminLayout() {
  const { user, loading, needsOnboarding } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <Spinner size={36} />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Forza onboarding se non completato
  if (needsOnboarding) return <Navigate to="/onboarding" replace />;

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <main style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
    </div>
  );
}

// ─── Onboarding layout (auth richiesta ma senza sidebar) ───────────────────
function OnboardingLayout() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

// ─── Guest-only guard ───────────────────────────────────────────────────────
function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

// ─── App ───────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />

          {/* Onboarding — auth senza sidebar */}
          <Route element={<OnboardingLayout />}>
            <Route path="/onboarding" element={<Onboarding />} />
          </Route>

          {/* Protected con sidebar */}
          <Route element={<AdminLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/beach" element={<BeachMapPage />} />
            <Route path="/tariffe" element={<Tariffe />} />
            <Route path="/availability" element={<Availability />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/beach-builder" element={<BeachBuilder />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/promozioni" element={<Promozioni />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/ordini-lido" element={<OrdiniLido />} />
            <Route path="/spiagge-it" element={<SpiaggeIt />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}